module.exports = __webpack_public_path__ + "static/media/note-site.ba17c120.png";